import { useCallback } from 'react';
import { useAuthContext } from '../components/AuthProvider';

export function useAuthenticatedFetch() {
  const { session } = useAuthContext();

  return useCallback(
    async (url: string, options: RequestInit = {}): Promise<Response> => {
      if (!session?.access_token) {
        throw new Error('No authentication token');
      }

      const isFormData = options.body instanceof FormData;
      const headers = isFormData
        ? { Authorization: `Bearer ${session.access_token}` }
        : {
            ...options.headers,
            Authorization: `Bearer ${session.access_token}`,
          };

      const res = await fetch(url, {
        ...options,
        headers,
      });

      if (res.status === 401) {
        throw new Error('Authentication expired');
      }

      if (res.status === 403) {
        throw new Error('Usage limit exceeded');
      }

      return res;
    },
    [session]
  );
}
